import { State } from '../reducers/rootReducer'

const backgroundImageTypeSelector = (state: State) => state.backgroundImageType

export default backgroundImageTypeSelector
